import { Fragment, useEffect } from "react";
import { FieldColumnName } from "../../fields/FieldColumnName";
import { FieldDefaultFormulaText } from "../../fields/FieldDefaultFormulaText";
import { PanelProps } from "../ModalCreateColumn";

export const PanelCreateColumnText = ({
  autoFocus = true,
  isDefinitionEditable = true,
  fields,
  onFieldChange,
}: PanelProps) => {
  // Update column definition
  useEffect(() => {
    onFieldChange("definition", {
      value: {
        kind: "text",
      },
      isValid: true,
    });
  }, [onFieldChange]);

  return (
    <Fragment>
      <FieldColumnName
        autoFocus={autoFocus}
        value={fields.name.value}
        onChange={(field) => {
          onFieldChange("name", {
            value: field.value,
            isValid: field.isValid,
            isDirty: true,
          });
        }}
      />

      <FieldDefaultFormulaText
        value={fields.default_formula.value}
        onChange={(value) => {
          onFieldChange("default_formula", {
            value: value,
            isValid: true,
          });
        }}
      />
    </Fragment>
  );
};
